import React from 'react';

import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import routePathEnum from 'enums/routePathEnum';

const PopisSluzby: React.FC = () => {
    const { navigateWorkaround } = useNavigateWorkaround();

    return (
        <>
            <h1
                style={{
                    color: '#006866',
                    fontWeight: 600,
                    marginTop: 10
                }}
                id="top"
            >
                <TranslateText>POPIS_SLUBY_TITLE</TranslateText>
            </h1>
            <Paragraph text="POPIS_SLUBY_TEXT" />

            <div
                style={{
                    display: 'block',
                    textDecoration: 'underline',
                    marginTop: 6,
                    color: '#006866'
                }}
            >
                <a onClick={() => navigateWorkaround(routePathEnum.LEI_PREHLED_UCTU)}>
                    <TranslateText>SLUZBA_ODKAZ</TranslateText>
                </a>
            </div>
        </>
    );
};

export default PopisSluzby;
